import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import AccordionTooltip from 'components/common/controls/AccordionTooltip';
import { PROVISO_MOCK_URL } from 'consts';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';
import { BankScrapingIframe } from './BankScrapingIframe';
import { SecurityBadges } from './SecurityBadges';
import Spinner from '../../Core/Spinner';

export const BankScrapingAU = ({
  iFrameUrl,
  isIframeLoaded,
  onIframeLoad,
  onIframeError,
}) => {
  const hasIframeUrl = iFrameUrl && iFrameUrl !== PROVISO_MOCK_URL;

  const translationKeys = {
    title: 'income_verification.title',
    shortText: 'income_verification.text.short',
    readMore: 'income_verification.readmore',
  };

  const translations = useTranslationSuffix('upgrade', translationKeys);

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={translations.title} />
      </h1>
      <div className="loan-form__step-body">
        <FormattedHTMLMessage id={translations.shortText} />
        <AccordionTooltip
          title={<FormattedMessage id={translations.readMore} />}
        >
          <FormattedHTMLMessage id="income_verification.text.long" />
        </AccordionTooltip>
        {
          hasIframeUrl ? (
            <>
              <div className="bank-scraping__wrapper">
                {!isIframeLoaded && (
                  <div className="bank-scraping__loading-overlay">
                    <Spinner />
                    <p className="bank-scraping__loading-text">
                      <FormattedMessage
                        id="income_verification.iframe.loading_text"
                      />
                    </p>
                  </div>
                )}
                <BankScrapingIframe
                  {...{ iFrameUrl }}
                  isLoaded={isIframeLoaded}
                  onLoad={onIframeLoad}
                  onError={onIframeError}
                />
              </div>
              <SecurityBadges />
            </>
          ) : (
            <div className="bank-scraping__loading">
              <Spinner />
              <p className="bank-scraping__loading-text">
                <FormattedMessage
                  id="income_verification.iframe.loading_text"
                />
              </p>
            </div>
          )
        }

      </div>
    </div>
  );
};

BankScrapingAU.propTypes = {
  iFrameUrl: PropTypes.string,
  isIframeLoaded: PropTypes.bool,
  onIframeLoad: PropTypes.func,
  onIframeError: PropTypes.func,
};
